<template>
    <div v-if="link" class="book-now-pay-later-warning">
        <Divider color="lightGrey" class="book-now-pay-later-warning-divider" />

        <div class="book-now-pay-later-warning-content">
            <Asset type="WarningSign" class="book-now-pay-later-warning-asset" />

            <div class="book-now-pay-later-warning-text">
                <Translation
                    class="book-now-pay-later-warning-title"
                    :translate="{ key: 'payment.borrowing_costs_money_title' }" />
                <span>
                    <Translation
                        :translate="{
                            key: 'payment.borrowing_costs_money_description',
                            suffix: ' ',
                        }" />
                    <Link :href="link.url" :label="link.label" target="_blank" />
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { Market } from '@shared/config/market/market.models';
    import store from '@/store';
    import Asset from '@ui/components/Asset/Asset.vue';
    import Divider from '@ui/components/Divider/Divider.vue';
    import Translation from '@ui/components/Translation/Translation.vue';
    import Link from '@ui/components/Link/Link.vue';

    export default defineComponent({
        name: 'BookNowPayLaterWarning',
        methods: { t },
        components: { Link, Translation, Divider, Asset },
        setup() {
            const market = computed<Market>(() => store.getters['general/getMarket']);

            const link = computed(() => {
                switch (market.value.locale) {
                    case 'sv':
                        return {
                            label: 'Konsumentverket',
                            url: 'https://www.konsumentverket.se/',
                        };
                    default:
                        return undefined;
                }
            });

            return {
                link,
            };
        },
    });
</script>

<style scoped lang="scss">
    @forward 'BookNowPayLaterWarning';
</style>
